  (() => {
    'use strict';

    const $ = (id) => document.getElementById(id);
    const config = window.VP_STL_CONVERTER_CONFIG || {};
    const customerLoggedIn = config.customerLoggedIn === true;
    const PENDING_DOWNLOAD_KEY = 'vp-stl-converter-pending-v1';
    const els = {
      dropZone: $('drop-zone'), fileInput: $('file-input'), fileChip: $('file-chip'), fileIcon: $('file-icon'), fileName: $('file-name'), fileMeta: $('file-meta'),
      layerList: $('layer-list'), layersEmpty: $('layers-empty'), layerTotal: $('layer-total'),
      thickness: $('material-thickness'), engraveDepth: $('engrave-depth'), scoreWidth: $('score-width'),
      convert: $('convert-button'), download: $('download-button'), svgMode: $('svg-mode'), modelMode: $('model-mode'),
      svgView: $('svg-view'), svgStage: $('svg-stage'), modelView: $('model-view'), emptyState: $('empty-state'),
      canvas: $('three-canvas'), modelBadge: $('model-badge'), statusbar: $('statusbar'), statusText: $('status-text'),
      loading: $('loading'), loadingText: $('loading-text'), toastStack: $('toast-stack'), geometryLab: $('geometry-lab'),
      infoButton: $('info-button'), infoPopup: $('info-popup'), infoClose: $('info-popup-close'),
      loginPopup: $('login-popup'), loginClose: $('login-popup-close'), loginCancel: $('login-popup-cancel'), loginContinue: $('login-popup-continue')
    };

    const PX_PER_MM = 96 / 25.4;
    const ROLES = ['CUT', 'ENGRAVE', 'SCORE', 'IGNORE'];
    const state = {
      file: null, svgText: '', safeSvgText: '', svgRoot: null, previewUrl: '', dimensions: null,
      layers: new Map(), activeView: 'svg', preview: { scale: 1, x: 0, y: 0, naturalW: 1, naturalH: 1 },
      triangles: [], modelReady: false, warnings: [], sceneReady: false
    };

    let renderer, scene, camera, controls, modelGroup, grid, animationFrame;

    initEvents();
    initThree();
    restorePendingDownload();

    function initEvents() {
      els.fileInput.addEventListener('change', (event) => {
        const file = event.target.files && event.target.files[0];
        if (file) importFile(file);
        event.target.value = '';
      });
      ['dragenter', 'dragover'].forEach((type) => els.dropZone.addEventListener(type, (event) => {
        event.preventDefault(); els.dropZone.classList.add('dragover');
      }));
      ['dragleave', 'drop'].forEach((type) => els.dropZone.addEventListener(type, (event) => {
        event.preventDefault(); els.dropZone.classList.remove('dragover');
      }));
      els.dropZone.addEventListener('drop', (event) => {
        const file = [...event.dataTransfer.files].find((item) => /\.(svg|dxf)$/i.test(item.name));
        if (file) importFile(file); else toast('Choose a file with an .svg or .dxf extension.', 'error');
      });
      els.svgMode.addEventListener('click', () => switchView('svg'));
      els.modelMode.addEventListener('click', () => { if (state.modelReady) switchView('model'); });
      els.convert.addEventListener('click', convertToModel);
      els.download.addEventListener('click', downloadStl);
      els.infoButton.addEventListener('click', openInfoPopup);
      els.infoClose.addEventListener('click', closeInfoPopup);
      els.infoPopup.addEventListener('click', (event) => { if (event.target === els.infoPopup) closeInfoPopup(); });
      els.loginClose.addEventListener('click', closeLoginPopup);
      els.loginCancel.addEventListener('click', closeLoginPopup);
      els.loginPopup.addEventListener('click', (event) => { if (event.target === els.loginPopup) closeLoginPopup(); });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (els.loginPopup.classList.contains('active')) closeLoginPopup();
        else if (els.infoPopup.classList.contains('active')) closeInfoPopup();
      });
      [els.thickness, els.engraveDepth, els.scoreWidth].forEach((input) => input.addEventListener('input', invalidateModel));

      let dragging = false, startX = 0, startY = 0, originX = 0, originY = 0;
      els.svgView.addEventListener('wheel', (event) => {
        if (!state.svgRoot) return;
        event.preventDefault();
        const rect = els.svgView.getBoundingClientRect();
        const px = event.clientX - rect.left;
        const py = event.clientY - rect.top;
        const old = state.preview.scale;
        const next = clamp(old * Math.exp(-event.deltaY * .0014), .03, 80);
        state.preview.x = px - (px - state.preview.x) * (next / old);
        state.preview.y = py - (py - state.preview.y) * (next / old);
        state.preview.scale = next;
        applySvgTransform();
      }, { passive: false });
      els.svgView.addEventListener('pointerdown', (event) => {
        if (!state.svgRoot || event.button !== 0) return;
        dragging = true; startX = event.clientX; startY = event.clientY; originX = state.preview.x; originY = state.preview.y;
        els.svgView.classList.add('panning'); els.svgView.setPointerCapture(event.pointerId);
      });
      els.svgView.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        state.preview.x = originX + event.clientX - startX; state.preview.y = originY + event.clientY - startY; applySvgTransform();
      });
      const stopDrag = () => { dragging = false; els.svgView.classList.remove('panning'); };
      els.svgView.addEventListener('pointerup', stopDrag); els.svgView.addEventListener('pointercancel', stopDrag);
      window.addEventListener('resize', () => { resizeThree(); if (state.svgRoot) fitSvgPreview(); });
    }

    function openInfoPopup() {
      els.infoPopup.classList.add('active');
      els.infoPopup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
      requestAnimationFrame(() => els.infoClose.focus());
    }

    function closeInfoPopup() {
      els.infoPopup.classList.remove('active');
      els.infoPopup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
      els.infoButton.focus();
    }

    function openLoginPopup() {
      savePendingDownload();
      els.loginPopup.classList.add('active');
      els.loginPopup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
      requestAnimationFrame(() => els.loginContinue.focus());
    }

    function closeLoginPopup() {
      els.loginPopup.classList.remove('active');
      els.loginPopup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
      els.download.focus();
    }

    function savePendingDownload() {
      if (!state.file || !state.svgText) return;
      try {
        const roles = {};
        state.layers.forEach((layer, color) => { roles[color] = layer.role; });
        sessionStorage.setItem(PENDING_DOWNLOAD_KEY, JSON.stringify({
          savedAt: Date.now(),
          fileName: state.file.name,
          fileType: state.file.type,
          sourceText: state.svgText,
          roles,
          thickness: els.thickness.value,
          engraveDepth: els.engraveDepth.value,
          scoreWidth: els.scoreWidth.value
        }));
      } catch (error) {
        console.warn('The pending converter state could not be saved.', error);
      }
    }

    async function restorePendingDownload() {
      if (!customerLoggedIn) return;
      let pending = null;
      try {
        const raw = sessionStorage.getItem(PENDING_DOWNLOAD_KEY);
        if (!raw) return;
        sessionStorage.removeItem(PENDING_DOWNLOAD_KEY);
        pending = JSON.parse(raw);
      } catch (error) {
        console.warn('The pending converter state could not be restored.', error);
        return;
      }
      if (!pending || !pending.sourceText || !pending.fileName || Date.now() - Number(pending.savedAt || 0) > 60 * 60 * 1000) return;
      els.thickness.value = pending.thickness || '3';
      els.engraveDepth.value = pending.engraveDepth || '0.3';
      els.scoreWidth.value = pending.scoreWidth || '0.4';
      const file = new File([pending.sourceText], pending.fileName, { type: pending.fileType || 'text/plain' });
      await importFile(file);
      if (pending.roles && typeof pending.roles === 'object') {
        state.layers.forEach((layer, color) => {
          if (ROLES.includes(pending.roles[color])) layer.role = pending.roles[color];
        });
        renderLayers();
      }
      if (state.svgRoot) await convertToModel();
      if (state.modelReady) toast('Sign-in complete. Your model was restored — select Download STL.');
      else toast('Sign-in complete. Your file and settings were restored.');
    }

    async function importFile(file) {
      const extension = file.name.toLowerCase().split('.').pop();
      if (!['svg','dxf'].includes(extension)) { toast('This converter imports SVG and DXF files.', 'error'); return; }
      if (extension === 'dxf') { await importDxfFile(file); return; }
      setLoading(true, 'Reading SVG colors and geometry…');
      try {
        state.svgRoot = null;
        els.convert.disabled = true;
        els.svgStage.innerHTML = '';
        els.geometryLab.innerHTML = '';
        if (state.previewUrl) { URL.revokeObjectURL(state.previewUrl); state.previewUrl = ''; }
        await yieldToBrowser();
        const text = await file.text();
        els.loadingText.textContent = 'Checking the SVG structure…';
        await yieldToBrowser();
        const parsed = new DOMParser().parseFromString(text, 'image/svg+xml');
        if (parsed.querySelector('parsererror') || !parsed.documentElement || parsed.documentElement.tagName.toLowerCase() !== 'svg') {
          throw new Error('The selected file is not a valid SVG.');
        }
        const safeRoot = sanitizeSvg(parsed.documentElement);
        // Illustrator, Silhouette Studio, etc. often store paths in <defs>
        // and render them with <use>. Materialize local references before
        // analyzing paths; referenced paths in <defs> are not rendered directly.
        expandSvgUses(safeRoot);
        const safeText = new XMLSerializer().serializeToString(safeRoot);
        state.file = file; state.svgText = text; state.safeSvgText = safeText;
        state.layers.clear(); state.warnings = [];
        invalidateModel();

        state.dimensions = getSvgDimensions(safeRoot);
        state.preview.naturalW = state.dimensions.widthMm * PX_PER_MM;
        state.preview.naturalH = state.dimensions.heightMm * PX_PER_MM;

        els.loadingText.textContent = 'Preparing contours for analysis…';
        els.geometryLab.innerHTML = safeText;
        const labRoot = els.geometryLab.querySelector('svg');
        labRoot.style.width = `${state.preview.naturalW}px`;
        labRoot.style.height = `${state.preview.naturalH}px`;
        await yieldToBrowser();
        await analyzeSvgGeometry(labRoot);
        els.geometryLab.innerHTML = '';

        const previewImage = document.createElement('img');
        previewImage.className = 'svg-preview-image';
        previewImage.alt = file.name;
        previewImage.draggable = false;
        previewImage.width = Math.max(1, Math.round(state.preview.naturalW));
        previewImage.height = Math.max(1, Math.round(state.preview.naturalH));
        previewImage.style.width = `${state.preview.naturalW}px`;
        previewImage.style.height = `${state.preview.naturalH}px`;
        const previewText = buildPreviewSvg(safeText);
        state.previewUrl = URL.createObjectURL(new Blob([previewText], { type: 'image/svg+xml' }));
        previewImage.src = state.previewUrl;
        els.svgStage.replaceChildren(previewImage);
        state.svgRoot = previewImage;
        renderLayers();

        els.fileIcon.textContent = 'SVG';
        els.fileName.textContent = file.name;
        els.fileMeta.textContent = `${formatBytes(file.size)} · ${formatNumber(state.dimensions.widthMm, 1)} × ${formatNumber(state.dimensions.heightMm, 1)} mm`;
        els.fileChip.classList.add('visible'); els.emptyState.classList.add('hidden'); els.convert.disabled = state.layers.size === 0;
        switchView('svg');
        requestAnimationFrame(fitSvgPreview);
        const objectCount = [...state.layers.values()].reduce((sum, layer) => sum + layer.items.length, 0);
        setStatus(`SVG ready · ${state.layers.size} ${countLabel(state.layers.size, 'color')} · ${objectCount} ${countLabel(objectCount, 'contour')}`, 'ready');
        toast(`Imported ${objectCount} ${countLabel(objectCount, 'contour')} in ${state.layers.size} ${countLabel(state.layers.size, 'color')}.`);
      } catch (error) {
        console.error(error); toast(error.message || 'Could not open the SVG file.', 'error'); setStatus('SVG import failed', 'warning');
      } finally { els.geometryLab.innerHTML = ''; setLoading(false); }
    }

    async function importDxfFile(file) {
      setLoading(true, 'Reading DXF layers and geometry…');
      try {
        state.svgRoot = null;
        els.convert.disabled = true;
        els.svgStage.innerHTML = '';
        els.geometryLab.innerHTML = '';
        if (state.previewUrl) { URL.revokeObjectURL(state.previewUrl); state.previewUrl = ''; }
        await yieldToBrowser();
        const text = await file.text();
        if (/^AutoCAD Binary DXF/i.test(text.trimStart())) throw new Error('Binary DXF is not supported. Save the file as ASCII DXF and try again.');
        els.loadingText.textContent = 'Parsing DXF geometry…';
        await yieldToBrowser();

        const parsed = parseDxfGeometry(text);
        state.file = file; state.svgText = text; state.safeSvgText = '';
        state.layers.clear(); state.warnings = parsed.warnings;
        invalidateModel();
        parsed.items.forEach((item) => {
          let layer = state.layers.get(item.color);
          if (!layer) { layer = { color: item.color, role: guessRole(item.color), items: [] }; state.layers.set(item.color, layer); }
          layer.items.push(item);
        });
        if (!state.layers.size) throw new Error('No supported 2D contours were found in the DXF file.');

        state.dimensions = { widthMm: parsed.widthMm, heightMm: parsed.heightMm, viewBox: { x: 0, y: 0, width: parsed.widthMm, height: parsed.heightMm } };
        state.preview.naturalW = state.dimensions.widthMm * PX_PER_MM;
        state.preview.naturalH = state.dimensions.heightMm * PX_PER_MM;
        const previewText = buildDxfPreviewSvg(parsed.items, parsed.widthMm, parsed.heightMm);
        state.safeSvgText = previewText;
        const previewImage = document.createElement('img');
        previewImage.className = 'svg-preview-image'; previewImage.alt = file.name; previewImage.draggable = false;
        previewImage.width = Math.max(1, Math.round(state.preview.naturalW));
        previewImage.height = Math.max(1, Math.round(state.preview.naturalH));
        previewImage.style.width = `${state.preview.naturalW}px`; previewImage.style.height = `${state.preview.naturalH}px`;
        state.previewUrl = URL.createObjectURL(new Blob([previewText], { type: 'image/svg+xml' }));
        previewImage.src = state.previewUrl;
        els.svgStage.replaceChildren(previewImage); state.svgRoot = previewImage;
        renderLayers();

        els.fileIcon.textContent = 'DXF';
        els.fileName.textContent = file.name;
        els.fileMeta.textContent = `${formatBytes(file.size)} · ${formatNumber(parsed.widthMm, 1)} × ${formatNumber(parsed.heightMm, 1)} mm`;
        els.fileChip.classList.add('visible'); els.emptyState.classList.add('hidden'); els.convert.disabled = false;
        switchView('svg'); requestAnimationFrame(fitSvgPreview);
        const warningSuffix = parsed.warnings.length ? ` · skipped: ${parsed.warnings.join(', ')}` : '';
        setStatus(`DXF ready · ${state.layers.size} ${countLabel(state.layers.size, 'color')} · ${parsed.items.length} ${countLabel(parsed.items.length, 'contour')}${warningSuffix}`, parsed.warnings.length ? 'warning' : 'ready');
        toast(`Imported ${parsed.items.length} DXF ${countLabel(parsed.items.length, 'contour')} in ${state.layers.size} ${countLabel(state.layers.size, 'color')}.${warningSuffix}`, parsed.warnings.length ? 'warning' : 'success', 5200);
      } catch (error) {
        console.error(error); toast(error.message || 'Could not open the DXF file.', 'error'); setStatus('DXF import failed', 'warning');
      } finally { setLoading(false); }
    }

    function parseDxfGeometry(text) {
      const lines = text.replace(/\r/g, '').split('\n');
      const pairs = [];
      for (let i = 0; i + 1 < lines.length; i += 2) {
        const code = Number(lines[i].trim());
        if (Number.isFinite(code)) pairs.push({ code, value: lines[i + 1].trim() });
      }
      let section = '', units = 0;
      const layers = new Map();
      const entities = [];
      for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i];
        if (pair.code === 0 && pair.value === 'SECTION') { section = pairs[i + 1]?.code === 2 ? pairs[++i].value : ''; continue; }
        if (pair.code === 0 && pair.value === 'ENDSEC') { section = ''; continue; }
        if (section === 'HEADER' && pair.code === 9 && pair.value === '$INSUNITS') {
          for (let j = i + 1; j < pairs.length && pairs[j].code !== 9 && pairs[j].code !== 0; j++) if (pairs[j].code === 70) { units = Number(pairs[j].value) || 0; break; }
        }
        if ((section === 'TABLES' || section === 'ENTITIES') && pair.code === 0 && !['TABLE','ENDTAB','SEQEND'].includes(pair.value)) {
          const group = [];
          let j = i + 1;
          while (j < pairs.length && pairs[j].code !== 0) group.push(pairs[j++]);
          if (section === 'TABLES' && pair.value === 'LAYER') {
            const name = dxfText(group, 2, '0');
            layers.set(name, { color: dxfEntityColor(group, null) });
          } else if (section === 'ENTITIES') entities.push({ type: pair.value, group });
          i = j - 1;
        }
      }

      const unitScale = dxfUnitToMm(units);
      const rawItems = [];
      const unsupported = new Set();
      for (let i = 0; i < entities.length; i++) {
        const entity = entities[i];
        const color = dxfEntityColor(entity.group, layers.get(dxfText(entity.group, 8, '0'))?.color || '#000000');
        let item = null;
        if (entity.type === 'LINE') {
          item = dxfItem([dxfPoint(entity.group, 10, 20), dxfPoint(entity.group, 11, 21)], false, color, unitScale);
        } else if (entity.type === 'LWPOLYLINE') {
          const vertices = dxfVertices(entity.group);
          item = dxfItem(expandDxfPolyline(vertices, Boolean(dxfNumber(entity.group, 70, 0) & 1), unitScale), Boolean(dxfNumber(entity.group, 70, 0) & 1), color, unitScale);
        } else if (entity.type === 'POLYLINE') {
          const vertices = [];
          while (i + 1 < entities.length && entities[i + 1].type === 'VERTEX') {
            const vertex = entities[++i].group;
            vertices.push({ x: dxfNumber(vertex, 10), y: dxfNumber(vertex, 20), bulge: dxfNumber(vertex, 42, 0) });
          }
          const closed = Boolean(dxfNumber(entity.group, 70, 0) & 1);
          item = dxfItem(expandDxfPolyline(vertices, closed, unitScale), closed, color, unitScale);
        } else if (entity.type === 'CIRCLE' || entity.type === 'ARC') {
          const cx = dxfNumber(entity.group, 10), cy = dxfNumber(entity.group, 20), radius = Math.abs(dxfNumber(entity.group, 40));
          let start = entity.type === 'CIRCLE' ? 0 : dxfNumber(entity.group, 50) * Math.PI / 180;
          let end = entity.type === 'CIRCLE' ? Math.PI * 2 : dxfNumber(entity.group, 51) * Math.PI / 180;
          while (end <= start) end += Math.PI * 2;
          const count = clamp(Math.ceil(radius * unitScale * (end - start) / .13), 12, 4096);
          const points = []; for (let n = 0; n <= count; n++) { const a = start + (end - start) * n / count; points.push({ x: cx + radius * Math.cos(a), y: cy + radius * Math.sin(a) }); }
          item = dxfItem(points, entity.type === 'CIRCLE', color, unitScale);
        } else if (entity.type === 'ELLIPSE') {
          const cx = dxfNumber(entity.group, 10), cy = dxfNumber(entity.group, 20), mx = dxfNumber(entity.group, 11), my = dxfNumber(entity.group, 21);
          const ratio = Math.abs(dxfNumber(entity.group, 40, 1)); let start = dxfNumber(entity.group, 41, 0), end = dxfNumber(entity.group, 42, Math.PI * 2);
          while (end <= start) end += Math.PI * 2;
          const approxLength = Math.PI * Math.hypot(mx, my) * (1 + ratio) * (end - start) / (Math.PI * 2) * unitScale;
          const count = clamp(Math.ceil(approxLength / .13), 16, 4096); const points = [];
          for (let n = 0; n <= count; n++) { const a = start + (end - start) * n / count; points.push({ x: cx + mx * Math.cos(a) - my * ratio * Math.sin(a), y: cy + my * Math.cos(a) + mx * ratio * Math.sin(a) }); }
          item = dxfItem(points, Math.abs(end - start - Math.PI * 2) < .001, color, unitScale);
        } else if (entity.type === 'SPLINE') {
          const controls = dxfVertices(entity.group, 10, 20).map((p) => ({ x: p.x, y: p.y }));
          const degree = clamp(Math.round(dxfNumber(entity.group, 71, 3)), 1, Math.max(1, controls.length - 1));
          let knots = dxfNumbers(entity.group, 40);
          if (knots.length !== controls.length + degree + 1) knots = makeClampedKnots(controls.length, degree);
          const closed = Boolean(dxfNumber(entity.group, 70, 0) & 1);
          const controlLength = controls.slice(1).reduce((sum, p, n) => sum + distance(p, controls[n]), 0) * unitScale;
          const count = clamp(Math.ceil(controlLength / .12), 16, 4096); const points = [];
          const from = knots[degree], to = knots[controls.length];
          for (let n = 0; n <= count; n++) points.push(deBoorPoint(controls, knots, degree, from + (to - from) * n / count));
          item = dxfItem(points, closed, color, unitScale);
        } else if (!['VERTEX','SEQEND'].includes(entity.type)) unsupported.add(entity.type);
        if (item && item.points.length >= (item.closed ? 4 : 2)) rawItems.push(item);
      }
      if (!rawItems.length) return { items: [], widthMm: 1, heightMm: 1, warnings: [...unsupported] };
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      rawItems.forEach((item) => item.points.forEach((p) => { minX = Math.min(minX,p.x); minY = Math.min(minY,p.y); maxX = Math.max(maxX,p.x); maxY = Math.max(maxY,p.y); }));
      const margin = .2;
      rawItems.forEach((item) => item.points.forEach((p) => { p.x += margin - minX; p.y += margin - minY; }));
      const warnings = [...unsupported]; if (!units) warnings.unshift('units missing — millimeters assumed');
      return { items: rawItems, widthMm: Math.max(.4, maxX - minX + margin * 2), heightMm: Math.max(.4, maxY - minY + margin * 2), warnings };
    }

    function dxfItem(points, closed, color, scale) {
      const converted = points.filter((p) => Number.isFinite(p.x) && Number.isFinite(p.y)).map((p) => ({ x: p.x * scale, y: -p.y * scale }));
      let simplified = simplifyPolyline(converted, .006);
      if (closed) simplified = closeRing(simplified);
      return { points: simplified, closed, strokeWidth: .1, sourceTag: 'dxf', color };
    }

    function dxfVertices(group, xCode = 10, yCode = 20) {
      const vertices = []; let current = null;
      group.forEach((pair) => {
        if (pair.code === xCode) { current = { x: Number(pair.value), y: 0, bulge: 0 }; vertices.push(current); }
        else if (current && pair.code === yCode) current.y = Number(pair.value);
        else if (current && pair.code === 42) current.bulge = Number(pair.value) || 0;
      });
      return vertices;
    }

    function expandDxfPolyline(vertices, closed, scale) {
      if (!vertices.length) return [];
      const result = [{ x: vertices[0].x, y: vertices[0].y }];
      const segmentCount = closed ? vertices.length : vertices.length - 1;
      for (let i = 0; i < segmentCount; i++) {
        const a = vertices[i], b = vertices[(i + 1) % vertices.length], bulge = a.bulge || 0;
        if (Math.abs(bulge) < 1e-8) { result.push({ x: b.x, y: b.y }); continue; }
        const dx = b.x - a.x, dy = b.y - a.y, chord = Math.hypot(dx,dy);
        if (chord < 1e-10) continue;
        const theta = 4 * Math.atan(bulge), mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
        const offset = chord * (1 - bulge * bulge) / (4 * bulge);
        const cx = mx - dy / chord * offset, cy = my + dx / chord * offset;
        const radius = Math.hypot(a.x - cx, a.y - cy), start = Math.atan2(a.y - cy, a.x - cx);
        const count = clamp(Math.ceil(Math.abs(theta) * radius * scale / .13), 3, 2048);
        for (let n = 1; n <= count; n++) { const angle = start + theta * n / count; result.push({ x: cx + radius * Math.cos(angle), y: cy + radius * Math.sin(angle) }); }
      }
      return result;
    }

    function deBoorPoint(points, knots, degree, t) {
      const n = points.length - 1; let k = n;
      if (t < knots[n + 1]) for (let i = degree; i <= n; i++) if (t >= knots[i] && t < knots[i + 1]) { k = i; break; }
      const d = []; for (let j = 0; j <= degree; j++) d[j] = { ...points[k - degree + j] };
      for (let r = 1; r <= degree; r++) for (let j = degree; j >= r; j--) {
        const i = k - degree + j, denominator = knots[i + degree - r + 1] - knots[i];
        const alpha = denominator ? (t - knots[i]) / denominator : 0;
        d[j] = { x: (1 - alpha) * d[j - 1].x + alpha * d[j].x, y: (1 - alpha) * d[j - 1].y + alpha * d[j].y };
      }
      return d[degree];
    }

    function makeClampedKnots(count, degree) {
      const knots = [], last = Math.max(1, count - degree);
      for (let i = 0; i < count + degree + 1; i++) knots.push(i <= degree ? 0 : i >= count ? last : i - degree);
      return knots;
    }

    function dxfPoint(group, xCode, yCode) { return { x: dxfNumber(group, xCode), y: dxfNumber(group, yCode) }; }
    function dxfNumbers(group, code) { return group.filter((pair) => pair.code === code).map((pair) => Number(pair.value)).filter(Number.isFinite); }
    function dxfNumber(group, code, fallback = 0) { const pair = group.find((item) => item.code === code); const value = pair ? Number(pair.value) : fallback; return Number.isFinite(value) ? value : fallback; }
    function dxfText(group, code, fallback = '') { return group.find((item) => item.code === code)?.value || fallback; }
    function dxfEntityColor(group, layerColor) {
      const trueColor = dxfNumber(group, 420, -1);
      if (trueColor >= 0) return `#${(trueColor & 0xffffff).toString(16).padStart(6,'0')}`;
      const colorPair = group.find((item) => item.code === 62);
      if (!colorPair) return layerColor || '#000000';
      const index = Math.abs(Math.round(Number(colorPair.value)));
      if (index === 0 || index === 256) return layerColor || '#000000';
      return dxfAciColor(index);
    }

    function dxfAciColor(index) {
      const basic = ['#000000','#ff0000','#ffff00','#00ff00','#00ffff','#0000ff','#ff00ff','#000000','#808080','#c0c0c0'];
      if (index < basic.length) return basic[index];
      const hue = ((index - 10) % 24) * 15, band = Math.floor((index - 10) / 24) % 10;
      const light = [50,75,38,63,25,55,18,45,12,32][band];
      return hslToHex(hue, band % 2 ? 75 : 100, light);
    }

    function hslToHex(h, s, l) {
      s /= 100; l /= 100; const c = (1 - Math.abs(2*l - 1)) * s, x = c * (1 - Math.abs((h/60)%2 - 1)), m = l - c/2;
      let rgb = h < 60 ? [c,x,0] : h < 120 ? [x,c,0] : h < 180 ? [0,c,x] : h < 240 ? [0,x,c] : h < 300 ? [x,0,c] : [c,0,x];
      return '#' + rgb.map((v) => Math.round((v+m)*255).toString(16).padStart(2,'0')).join('');
    }

    function dxfUnitToMm(code) {
      return ({ 0:1, 1:25.4, 2:304.8, 3:1609344, 4:1, 5:10, 6:1000, 7:1000000, 8:.0000254, 9:.0254, 10:914.4, 11:1e-7, 12:1e-6, 13:.001, 14:100, 15:10000, 16:100000, 17:1e12, 21:1200/3.937, 22:100/3.937, 23:3600/3.937, 24:6336000/3.937 })[code] || 1;
    }

    function buildDxfPreviewSvg(items, width, height) {
      const paths = items.map((item) => {
        const color = item.color;
        const d = item.points.map((p,i) => `${i ? 'L' : 'M'}${p.x.toFixed(4)} ${p.y.toFixed(4)}`).join(' ') + (item.closed ? ' Z' : '');
        return `<path d="${d}" fill="none" stroke="${color}" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>`;
      }).join('');
      return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}mm" height="${height}mm" viewBox="0 0 ${width} ${height}">${paths}</svg>`;
    }

    function sanitizeSvg(source) {
      const root = source;
      root.querySelectorAll('script, foreignObject, iframe, object, embed').forEach((node) => node.remove());
      root.querySelectorAll('*').forEach((node) => {
        [...node.attributes].forEach((attr) => {
          const name = attr.name.toLowerCase(); const value = attr.value.trim().toLowerCase();
          if (name.startsWith('on') || ((name === 'href' || name.endsWith(':href')) && value.startsWith('javascript:'))) node.removeAttribute(attr.name);
        });
      });
      return root;
    }

    function expandSvgUses(root) {
      // Materialize rendered <use href="#id"> / <use xlink:href="#id"> references.
      // Keep the <defs> in place for gradients, clipping paths, etc., while
      // making the referenced geometry visible to the contour analyzer.
      const SVG_NS = 'http://www.w3.org/2000/svg';
      const XLINK_NS = 'http://www.w3.org/1999/xlink';
      const references = new Map();
      root.querySelectorAll('[id]').forEach((el) => {
        if (!references.has(el.id)) references.set(el.id, el);
      });
      let expandedCount = 0;
      const MAX_EXPANSIONS = 20000;

      function materialize(use, chain) {
        const href = (use.getAttribute('href') || use.getAttributeNS(XLINK_NS, 'href') || '').trim();
        // External references are intentionally not fetched for user safety.
        if (!href.startsWith('#') || href.length <= 1) return;
        const id = href.slice(1);
        const target = references.get(id);
        if (!target) return;
        if (chain.has(id)) throw new Error('The SVG has a circular <use> reference.');
        if (++expandedCount > MAX_EXPANSIONS || chain.size >= 32) {
          throw new Error('The SVG contains too many nested <use> references.');
        }
        const wrapper = use.ownerDocument.createElementNS(SVG_NS, 'g');
        [...use.attributes].forEach((attr) => {
          if (['href', 'x', 'y', 'width', 'height', 'transform'].includes(attr.localName)) return;
          wrapper.setAttributeNS(attr.namespaceURI, attr.name, attr.value);
        });
        // In SVG, x/y position is applied inside the element's own transform.
        const x = Number.parseFloat(use.getAttribute('x') || '0') || 0;
        const y = Number.parseFloat(use.getAttribute('y') || '0') || 0;
        const transform = (use.getAttribute('transform') || '').trim();
        const translation = x || y ? `translate(${x} ${y})` : '';
        if (transform || translation) wrapper.setAttribute('transform', [transform, translation].filter(Boolean).join(' '));
        const clone = target.cloneNode(true);
        // <symbol> is a definition and won't display when copied as-is.
        // Use an SVG viewport to preserve its viewBox on instantiation.
        if (clone.localName.toLowerCase() === 'symbol') {
          const viewport = use.ownerDocument.createElementNS(SVG_NS, 'svg');
          [...clone.attributes].forEach((attr) => {
            if (attr.localName !== 'id') viewport.setAttributeNS(attr.namespaceURI, attr.name, attr.value);
          });
          ['width','height'].forEach((name) => {
            if (use.hasAttribute(name)) viewport.setAttribute(name, use.getAttribute(name));
          });
          while (clone.firstChild) viewport.appendChild(clone.firstChild);
          wrapper.appendChild(viewport);
        } else {
          wrapper.appendChild(clone);
        }
        use.replaceWith(wrapper);
        const nextChain = new Set(chain); nextChain.add(id);
        [...wrapper.querySelectorAll('use')].forEach((nested) => {
          // Ancestor replacement may have already replaced the nested <use>.
          if (nested.isConnected) materialize(nested, nextChain);
        });
      }

      const uses = [...root.querySelectorAll('use')].filter((el) =>
        !el.closest('defs,clipPath,mask,pattern,marker,symbol'));
      uses.forEach((el) => { if (el.isConnected) materialize(el, new Set()); });
    }

    function buildPreviewSvg(svgText) {
      const visibilityStyle = '<style id="vp-preview-visibility">path,line,polyline,polygon,rect,circle,ellipse{vector-effect:non-scaling-stroke!important;stroke-width:1.35px!important;stroke-opacity:1!important}</style>';
      return svgText.replace(/(<svg\b[^>]*>)/i, `$1${visibilityStyle}`);
    }

    function getSvgDimensions(root) {
      const viewBox = (root.getAttribute('viewBox') || '').trim().split(/[ ,]+/).map(Number);
      const vb = viewBox.length === 4 && viewBox.every(Number.isFinite) ? { x: viewBox[0], y: viewBox[1], width: Math.abs(viewBox[2]), height: Math.abs(viewBox[3]) } : null;
      const widthMm = lengthToMm(root.getAttribute('width'), vb ? vb.width : 100);
      const heightMm = lengthToMm(root.getAttribute('height'), vb ? vb.height : 100);
      return { widthMm: widthMm || (vb ? vb.width : 100), heightMm: heightMm || (vb ? vb.height : 100), viewBox: vb };
    }

    function lengthToMm(value, fallback) {
      if (!value) return fallback;
      const match = String(value).trim().match(/^([+-]?[\d.]+(?:e[+-]?\d+)?)\s*(mm|cm|in|px|pt|pc)?$/i);
      if (!match) return fallback;
      const n = Number(match[1]); const unit = (match[2] || 'px').toLowerCase();
      return unit === 'mm' ? n : unit === 'cm' ? n * 10 : unit === 'in' ? n * 25.4 : unit === 'pt' ? n * 25.4 / 72 : unit === 'pc' ? n * 25.4 / 6 : n / PX_PER_MM;
    }

    // SVG paths may contain hundreds of separate contours inside ONE <path>.
    // Do not sample such a path using getTotalLength()/getPointAtLength() as a
    // single curve: uniform sampling loses sharp corners and bridges subpaths.
    // Instead parse SVG commands, keep original line endpoints, and flatten
    // Beziers/arcs adaptively in physical millimeters.
    async function analyzeSvgGeometry(root) {
      const tags = 'path,line,polyline,polygon,rect,circle,ellipse';
      const elements = [...root.querySelectorAll(tags)].filter((el) => !el.closest('defs,clipPath,mask,pattern,marker,symbol'));
      const rootRect = root.getBoundingClientRect();
      if (rootRect.width <= 0 || rootRect.height <= 0) throw new Error('SVG geometry viewport has no visible dimensions.');
      const scaleX = state.dimensions.widthMm / rootRect.width;
      const scaleY = state.dimensions.heightMm / rootRect.height;
      let totalPoints = 0;
      const MAX_POINTS = 650000;
      const fillOnlyColors = new Set(), strokedColors = new Set(), cutStrokeColors = new Set();
      let lastYieldAt = performance.now();

      for (let index = 0; index < elements.length; index++) {
        const element = elements[index];
        const tag = element.tagName.toLowerCase();
        const computed = getComputedStyle(element);
        // The geometry lab itself may intentionally be visually hidden.
        if (element.getAttribute('display') === 'none' || element.getAttribute('visibility') === 'hidden' || Number(computed.opacity) === 0) continue;
        const stroke = normalizeColor(computed.stroke);
        const fill = normalizeColor(computed.fill);
        const color = stroke || fill;
        if (!color) continue;
        if (stroke) { strokedColors.add(color); if (guessRole(color) === 'CUT') cutStrokeColors.add(color); }
        else fillOnlyColors.add(color);
        const ctm = element.getCTM();
        if (!ctm) continue;
        const toMm = (p) => ({ x: (ctm.a * p.x + ctm.c * p.y + ctm.e) * scaleX,
                               y: (ctm.b * p.x + ctm.d * p.y + ctm.f) * scaleY });
        const strokeScale = (Math.hypot(ctm.a * scaleX, ctm.b * scaleY) + Math.hypot(ctm.c * scaleX, ctm.d * scaleY)) / 2;
        const strokeWidth = parseCssPx(computed.strokeWidth) * strokeScale;
        let contours = [];

        if (tag === 'path') {
          // An SVG <path> can include a new M command after each z command.
          // Parsing each subpath separately preserves every closed island and
          // the sharp tips of laser engraving artwork.
          contours = parseSvgPathContours(element.getAttribute('d') || '', toMm);
        } else {
          let length;
          try { length = element.getTotalLength(); } catch (_) { continue; }
          if (!Number.isFinite(length) || length <= 0) continue;
          const physicalLength = length * Math.max(.00001, strokeScale);
          const explicitlyClosed = ['polygon','rect','circle','ellipse'].includes(tag);
          const samples = clamp(Math.ceil(physicalLength / .08), explicitlyClosed ? 12 : 2, 18000);
          const points = [];
          for (let i = 0; i <= samples; i++) points.push(toMm(element.getPointAtLength(length * i / samples)));
          contours = [{ points, closed: explicitlyClosed }];
        }

        for (const contour of contours) {
          let { points, closed } = contour;
          if (points.length < 2) continue;
          // Remove ONLY identical consecutive vertices, not near-by sharp
          // corners: those are essential on small ornamental engravings.
          points = points.filter((p, i) => !i || distance(p, points[i - 1]) > 1e-7);
          if (closed) points = closeRing(points);
          if (points.length < (closed ? 4 : 2)) continue;
          totalPoints += points.length;
          if (totalPoints > MAX_POINTS) throw new Error('This SVG contains too many contour vertices. Simplify the source artwork before converting.');
          let layer = state.layers.get(color);
          if (!layer) {
            layer = { color, role: guessRole(color), items: [] };
            state.layers.set(color, layer);
          }
          layer.items.push({ points, closed, strokeWidth: Math.max(.08, strokeWidth), sourceTag: tag });
        }
        if (performance.now() - lastYieldAt > 12) {
          els.loadingText.textContent = `Analyzing contours · ${Math.round((index + 1) / Math.max(1, elements.length) * 100)}%`;
          await yieldToBrowser();
          lastYieldAt = performance.now();
        }
      }
      // If the file has explicit CUT stroke outlines, separate fill-only
      // colors are likely engraving masks (as in the supplied SVG).
      // Keep the old CUT default for files consisting ONLY of black fills.
      if (cutStrokeColors.size) fillOnlyColors.forEach((color) => {
        if (!strokedColors.has(color)) {
          const layer = state.layers.get(color);
          if (layer && layer.role === 'CUT') layer.role = 'ENGRAVE';
        }
      });
      if (!state.layers.size) throw new Error('No visible vector lines or shapes were found in the SVG file.');
    }

    function parseSvgPathContours(d, toMm) {
      const tokens = d.match(/[a-zA-Z]|[+-]?(?:\d+\.?\d*|\.\d+)(?:[eE][+-]?\d+)?/g) || [];
      const contours = [];
      const counts = { M:2, L:2, H:1, V:1, C:6, S:4, Q:4, T:2, A:7 };
      let i = 0, command = '', previous = '';
      let current = {x:0,y:0}, first = null, points = [];
      let lastCubic = null, lastQuad = null;
      const isCommand = (str) => /^[a-zA-Z]$/.test(str);
      const emit = (closed) => {
        if (points.length > 1) contours.push({points, closed});
        points = []; first = null;
      };
      const append = (p) => { points.push(toMm(p)); current = p; };
      const readPoint = (x, y, relative) => ({ x:relative ? current.x+x : x, y:relative ? current.y+y : y });

      while (i < tokens.length) {
        if (isCommand(tokens[i])) {
          command = tokens[i++];
          if (command === 'Z' || command === 'z') {
            if (first && points.length > 1) {
              if (distance(points[0],points[points.length-1]) > 1e-7) points.push({...points[0]});
              current = {...first};
              emit(true);
            }
            lastCubic = lastQuad = null;
            previous = 'Z'; command = '';
            continue;
          }
        }
        const type = command.toUpperCase();
        const count = counts[type];
        if (!count || i + count > tokens.length || tokens.slice(i,i+count).some(isCommand)) {
          // Unknown/malformed commands should not accidentally connect contours.
          if (i < tokens.length && !isCommand(tokens[i])) i++;
          else if (i >= tokens.length) break;
          command = '';
          continue;
        }
        const args = tokens.slice(i,i+count).map(Number); i += count;
        const rel = command === command.toLowerCase();
        const base = {...current};
        let endpoint = null;
        if (type === 'M') {
          if (points.length) emit(false);
          endpoint = readPoint(args[0],args[1],rel);
          first = {...endpoint}; append(endpoint);
          command = rel ? 'l' : 'L';
        } else if (type === 'L') {
          endpoint = readPoint(args[0],args[1],rel); append(endpoint);
        } else if (type === 'H') {
          endpoint = {x:rel ? current.x+args[0] : args[0],y:current.y}; append(endpoint);
        } else if (type === 'V') {
          endpoint = {x:current.x,y:rel ? current.y+args[0] : args[0]}; append(endpoint);
        } else if (type === 'C' || type === 'S') {
          let c1, c2;
          if (type === 'C') {
            c1 = {x:args[0]+(rel ? base.x:0),y:args[1]+(rel ? base.y:0)};
            c2 = {x:args[2]+(rel ? base.x:0),y:args[3]+(rel ? base.y:0)};
            endpoint = {x:args[4]+(rel ? base.x:0),y:args[5]+(rel ? base.y:0)};
          } else {
            c1 = (previous === 'C' || previous === 'S') && lastCubic
              ? {x:2*base.x-lastCubic.x,y:2*base.y-lastCubic.y} : {...base};
            c2 = {x:args[0]+(rel ? base.x:0),y:args[1]+(rel ? base.y:0)};
            endpoint = {x:args[2]+(rel ? base.x:0),y:args[3]+(rel ? base.y:0)};
          }
          flattenSvgCubic(toMm(base),toMm(c1),toMm(c2),toMm(endpoint),points);
          current = endpoint; lastCubic = c2;
        } else if (type === 'Q' || type === 'T') {
          let q;
          if (type === 'Q') {
            q = {x:args[0]+(rel ? base.x:0),y:args[1]+(rel ? base.y:0)};
            endpoint = {x:args[2]+(rel ? base.x:0),y:args[3]+(rel ? base.y:0)};
          } else {
            q = (previous === 'Q' || previous === 'T') && lastQuad
              ? {x:2*base.x-lastQuad.x,y:2*base.y-lastQuad.y} : {...base};
            endpoint = readPoint(args[0],args[1],rel);
          }
          const c1 = {x:base.x+2*(q.x-base.x)/3,y:base.y+2*(q.y-base.y)/3};
          const c2 = {x:endpoint.x+2*(q.x-endpoint.x)/3,y:endpoint.y+2*(q.y-endpoint.y)/3};
          flattenSvgCubic(toMm(base),toMm(c1),toMm(c2),toMm(endpoint),points);
          current = endpoint; lastQuad = q;
        } else if (type === 'A') {
          endpoint = readPoint(args[5],args[6],rel);
          flattenSvgArc(base, endpoint, args[0],args[1],args[2],Boolean(args[3]),Boolean(args[4]),toMm,points);
          current = endpoint;
        }
        if (type !== 'C' && type !== 'S') lastCubic = null;
        if (type !== 'Q' && type !== 'T') lastQuad = null;
        previous = type;
      }
      if (points.length) {
        // Open SVG paths that return to their initial coordinate are closed.
        const closed = points.length > 2 && distance(points[0],points[points.length-1]) < 1e-6;
        emit(closed);
      }
      return contours;
    }

    function flattenSvgCubic(a,b,c,d,out,tolerance=.018,level=0) {
      // Flatness is evaluated AFTER the path's SVG transform, in millimeters.
      const dx=d.x-a.x, dy=d.y-a.y, len=Math.hypot(dx,dy);
      const flatness = len > 1e-12
        ? Math.max(
            Math.abs(dx*(b.y-a.y)-dy*(b.x-a.x))/len,
            Math.abs(dx*(c.y-a.y)-dy*(c.x-a.x))/len,
            distance(a,b)+distance(b,d)-len,
            distance(a,c)+distance(c,d)-len
          )
        : Math.max(distance(a,b),distance(a,c));
      if (flatness <= tolerance && (len <= .25 || flatness <= tolerance*.5) || level >= 15) {
        out.push({...d}); return;
      }
      const mid=(p,q)=>({x:(p.x+q.x)/2,y:(p.y+q.y)/2});
      const ab=mid(a,b),bc=mid(b,c),cd=mid(c,d),abc=mid(ab,bc),bcd=mid(bc,cd),middle=mid(abc,bcd);
      flattenSvgCubic(a,ab,abc,middle,out,tolerance,level+1);
      flattenSvgCubic(middle,bcd,cd,d,out,tolerance,level+1);
    }

    function flattenSvgArc(from,to,rx,ry,rotation,large,sweep,toMm,out) {
      rx=Math.abs(rx);ry=Math.abs(ry);
      if (rx < 1e-12 || ry < 1e-12 || distance(from,to) < 1e-12) {out.push(toMm(to));return;}
      const phi=rotation*Math.PI/180,cos=Math.cos(phi),sin=Math.sin(phi);
      const dx=(from.x-to.x)/2,dy=(from.y-to.y)/2;
      const x1=cos*dx+sin*dy,y1=-sin*dx+cos*dy;
      const ratio=x1*x1/(rx*rx)+y1*y1/(ry*ry);
      if (ratio>1){const factor=Math.sqrt(ratio);rx*=factor;ry*=factor;}
      const rad=Math.max(0,(rx*rx*ry*ry-rx*rx*y1*y1-ry*ry*x1*x1)/(rx*rx*y1*y1+ry*ry*x1*x1||1));
      const coef=(large===sweep?-1:1)*Math.sqrt(rad);
      const cx1=coef*rx*y1/ry,cy1=-coef*ry*x1/rx;
      const cx=cos*cx1-sin*cy1+(from.x+to.x)/2,cy=sin*cx1+cos*cy1+(from.y+to.y)/2;
      const u=[(x1-cx1)/rx,(y1-cy1)/ry],v=[(-x1-cx1)/rx,(-y1-cy1)/ry];
      const start=Math.atan2(u[1],u[0]);
      let delta=Math.atan2(u[0]*v[1]-u[1]*v[0],u[0]*v[0]+u[1]*v[1]);
      if(!sweep&&delta>0)delta-=2*Math.PI;
      if(sweep&&delta<0)delta+=2*Math.PI;
      // Split at <= 18 degrees, then bound chord error in physical units.
      const center=toMm({x:cx,y:cy});
      const maxR=Math.max(distance(center,toMm({x:cx+rx*cos,y:cy+rx*sin})),distance(center,toMm({x:cx-ry*sin,y:cy+ry*cos})));
      const maxStep=Math.min(Math.PI/10,2*Math.acos(clamp(1-.018/Math.max(maxR,.018),-1,1)));
      const steps=clamp(Math.ceil(Math.abs(delta)/Math.max(maxStep,.001)),1,16384);
      for(let j=1;j<=steps;j++){
        if(j===steps){out.push(toMm(to));break;}
        const angle=start+delta*j/steps,ex=rx*Math.cos(angle),ey=ry*Math.sin(angle);
        out.push(toMm({x:cx+cos*ex-sin*ey,y:cy+sin*ex+cos*ey}));
      }
    }

    function normalizeColor(value) {
      if (!value || value === 'none' || value === 'transparent' || value.includes('rgba(0, 0, 0, 0)')) return null;
      const hex = value.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
      if (hex) {
        const v = hex[1].length === 3 ? hex[1].split('').map((c) => c + c).join('') : hex[1];
        return `#${v.toLowerCase()}`;
      }
      const rgb = value.match(/rgba?\(\s*([\d.]+)[, ]+\s*([\d.]+)[, ]+\s*([\d.]+)/i);
      if (rgb) return '#' + [rgb[1], rgb[2], rgb[3]].map((n) => clamp(Math.round(Number(n)), 0, 255).toString(16).padStart(2, '0')).join('');
      const probe = document.createElement('span'); probe.style.color = value; document.body.appendChild(probe);
      const resolved = getComputedStyle(probe).color; probe.remove();
      return resolved !== value ? normalizeColor(resolved) : null;
    }

    function guessRole(color) {
      const [r,g,b] = hexRgb(color);
      if (b > r * 1.25 && b > g * 1.12) return 'ENGRAVE';
      if (g > r * 1.2 && g > b * 1.2) return 'SCORE';
      if (Math.max(r,g,b) < 60) return 'CUT';
      if (r > g * 1.25 && r > b * 1.25) return 'CUT';
      return 'ENGRAVE';
    }

    function renderLayers() {
      els.layerList.innerHTML = '';
      [...state.layers.values()].forEach((layer) => {
        const row = document.createElement('div'); row.className = 'layer-row';
        row.innerHTML = `<span class="swatch"></span><span class="layer-info"><span class="layer-color"></span><span class="layer-count"></span></span><select aria-label="Color operation"></select>`;
        row.querySelector('.swatch').style.background = layer.color;
        row.querySelector('.layer-color').textContent = layer.color;
        row.querySelector('.layer-count').textContent = `${layer.items.length} ${countLabel(layer.items.length, 'contour')}`;
        const select = row.querySelector('select');
        ROLES.forEach((role) => { const option = document.createElement('option'); option.value = role; option.textContent = role; select.appendChild(option); });
        select.value = layer.role;
        select.addEventListener('change', () => { layer.role = select.value; invalidateModel(); });
        els.layerList.appendChild(row);
      });
      els.layersEmpty.style.display = state.layers.size ? 'none' : 'block';
      els.layerTotal.textContent = `${state.layers.size} ${countLabel(state.layers.size, 'color')}`;
    }

    function fitSvgPreview() {
      const svg = els.svgStage.querySelector('.svg-preview-image'); if (!svg) return;
      const w = els.svgView.clientWidth, h = els.svgView.clientHeight;
      const scale = clamp(Math.min((w - 96) / state.preview.naturalW, (h - 112) / state.preview.naturalH), .03, 12);
      state.preview.scale = scale;
      state.preview.x = (w - state.preview.naturalW * scale) / 2;
      state.preview.y = (h - state.preview.naturalH * scale) / 2 + 16;
      applySvgTransform();
    }
    function applySvgTransform() {
      const svg = els.svgStage.querySelector('.svg-preview-image'); if (svg) svg.style.transform = `translate(${state.preview.x}px, ${state.preview.y}px) scale(${state.preview.scale})`;
    }

    function invalidateModel() {
      state.modelReady = false; state.triangles = [];
      els.download.disabled = true; els.modelMode.disabled = true; els.modelMode.classList.remove('model-ready');
      els.modelBadge.classList.remove('visible');
      if (modelGroup) clearGroup(modelGroup);
      if (state.activeView === 'model') switchView('svg');
    }

    async function convertToModel() {
      if (!state.svgRoot || !window.THREE) { toast('The 3D library is not ready. Check your internet connection.', 'error'); return; }
      if (!window.polygonClipping) { toast('The precision geometry module is not ready. Check your internet connection.', 'error'); return; }
      const thickness = Number(els.thickness.value), depth = Number(els.engraveDepth.value), scoreWidth = Number(els.scoreWidth.value);
      if (!(thickness > 0)) { toast('Extrusion height must be greater than 0.', 'error'); return; }
      if (!(depth > 0 && depth < thickness)) { toast('Engraving depth must be greater than 0 and less than the extrusion height.', 'error'); return; }
      if (!(scoreWidth > 0)) { toast('Score width must be greater than 0.', 'error'); return; }
      setLoading(true, 'Detecting parts and openings…');
      await nextFrame();
      try {
        const cutItems = layerItems('CUT').filter((item) => item.closed);
        const openCuts = layerItems('CUT').filter((item) => !item.closed).length;
        if (!cutItems.length) throw new Error('CUT requires at least one closed contour.');
        const contours = buildContourTree(cutItems.map((item) => cleanRing(item.points)).filter((ring) => Math.abs(polygonArea(ring)) > .01));
        const parts = contours.filter((contour) => contour.depth % 2 === 0);
        if (!parts.length) throw new Error('Could not detect any outer part contours.');

        els.loadingText.textContent = 'Building engraving and score recesses…'; await nextFrame();
        const engraveItems = layerItems('ENGRAVE');
        const scoreItems = layerItems('SCORE');
        const triangles = [];
        const partMeshes = [];
        let grooveCount = 0;

        parts.forEach((part, partIndex) => {
          const outer = part.points;
          const cutHoles = part.children.filter((child) => child.depth === part.depth + 1).map((child) => child.points);
          const assignedEngraves = engraveItems.filter((item) => polylineBelongsToPart(item.points, outer, cutHoles));
          const assignedScores = scoreItems.filter((item) => polylineBelongsToPart(item.points, outer, cutHoles));
          const grooves = [];
          // Closed ENGRAVE contours use the same even/odd nesting rule as CUT:
          // depth 0 is engraved, depth 1 is an untouched island, depth 2 is
          // engraved again, and so on. Open engrave paths remain stroked lines.
          const closedEngraveRings = assignedEngraves
            .filter((item) => item.closed)
            .map((item) => cleanRing(item.points))
            .filter((ring) => Math.abs(polygonArea(ring)) > .0001);
          const engraveContours = buildContourTree(closedEngraveRings);
          engraveContours.filter((contour) => contour.depth % 2 === 0).forEach((contour) => {
            const islands = contour.children
              .filter((child) => child.depth === contour.depth + 1)
              .map((child) => child.points);
            const polygon = [contour.points, ...islands];
            if (validGroovePolygon(polygon, outer, cutHoles)) grooves.push({ polygon, depth, type: 'engrave' });
          });
          assignedEngraves.filter((item) => !item.closed).forEach((item) => {
            const polygon = strokeToPolygonGeometry(item.points, Math.max(.28, item.strokeWidth), false);
            if (validGroovePolygon(polygon, outer, cutHoles)) grooves.push({ polygon, depth, type: 'engrave' });
          });
          assignedScores.forEach((item) => {
            const polygon = strokeToPolygonGeometry(item.points, scoreWidth, item.closed);
            if (validGroovePolygon(polygon, outer, cutHoles)) grooves.push({ polygon, depth, type: 'score' });
          });
          grooveCount += grooves.length;
          const partTriangles = buildPartTriangles(outer, cutHoles, grooves, thickness);
          if (!partTriangles.length) throw new Error(`Could not triangulate part ${partIndex + 1}. Check the CUT contours for intersections.`);
          triangles.push(...partTriangles);
          partMeshes.push({ triangles: partTriangles, index: partIndex });
        });

        if (!triangles.length) throw new Error('The generated model contains no triangles.');
        centerTrianglesOnBuildPlate(triangles);
        state.triangles = triangles; state.modelReady = true;
        buildThreeModel(partMeshes);
        els.download.disabled = false; els.modelMode.disabled = false; els.modelMode.classList.add('model-ready');
        const bounds = triangleBounds(triangles);
        els.modelBadge.innerHTML = `<strong>STL ready</strong><br>${parts.length} ${countLabel(parts.length,'part')} · ${grooveCount} ${countLabel(grooveCount,'recess')}<br>${formatNumber(bounds.width,1)} × ${formatNumber(bounds.height,1)} × ${formatNumber(bounds.depth,1)} mm<br>${triangles.length.toLocaleString('en-US')} ${countLabel(triangles.length,'triangle')}`;
        els.modelBadge.classList.add('visible');
        const warningText = openCuts ? ` · ${openCuts} open CUT ${countLabel(openCuts, 'contour')} skipped` : '';
        setStatus(`3D model ready${warningText}`, openCuts ? 'warning' : 'ready');
        switchView('model');
        toast(`Created ${parts.length} ${countLabel(parts.length,'part')} and ${grooveCount} ${countLabel(grooveCount,'recess')}.${warningText}`, openCuts ? 'warning' : 'success');
      } catch (error) {
        console.error(error); state.modelReady = false; toast(error.message || 'Could not build the 3D model.', 'error'); setStatus('Conversion failed', 'warning');
      } finally { setLoading(false); }
    }

    function layerItems(role) {
      return [...state.layers.values()].filter((layer) => layer.role === role).flatMap((layer) => layer.items);
    }

    function buildContourTree(rings) {
      const nodes = rings.map((points, index) => ({ points, index, area: Math.abs(polygonArea(points)), parent: null, children: [], depth: 0 }));
      nodes.sort((a,b) => b.area - a.area);
      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i]; let parent = null;
        for (let j = 0; j < i; j++) {
          const candidate = nodes[j];
          if (pointInPolygon(node.points[0], candidate.points) && (!parent || candidate.area < parent.area)) parent = candidate;
        }
        if (parent) { node.parent = parent; parent.children.push(node); node.depth = parent.depth + 1; }
      }
      return nodes;
    }

    function polylineBelongsToPart(points, outer, holes) {
      if (!points.length) return false;
      const probes = [points[0], points[Math.floor(points.length / 2)], points[points.length - 1]];
      return probes.some((point) => pointInPolygon(point, outer) && !holes.some((hole) => pointInPolygon(point, hole)));
    }

    function validGroovePolygon(polygon, outer, holes) {
      if (!polygon || !polygon[0] || polygon[0].length < 4 || Math.abs(polygonArea(polygon[0])) < .002) return false;
      return true;
    }

    function buildPartTriangles(outerRing, cutHoleRings, grooves, thickness) {
      const triangles = [];
      const outer = orientRing(cleanRing(outerRing), true);
      const cutHoles = cutHoleRings.map((ring) => orientRing(cleanRing(ring), false));
      const partPolygon = [ringToCoordinates(outer), ...cutHoles.map(ringToCoordinates)];
      let grooveGeometry = [];
      if (grooves.length) {
        const groovePolygons = grooves.map((groove) => groove.polygon.map((ring) => ringToCoordinates(cleanRing(ring))));
        grooveGeometry = clipGroovesToPart(partPolygon, groovePolygons);
      }
      let topGeometry = [partPolygon];
      if (grooveGeometry.length) {
        try { topGeometry = polygonClipping.difference(partPolygon, grooveGeometry); }
        catch (_) { grooveGeometry = []; addGeometryWarning('One complex recess set was skipped because its contours self-intersect.'); }
      }
      addPolygonGeometryFace(triangles, partPolygon, 0, true);
      addPolygonGeometryFace(triangles, topGeometry, thickness, false);
      addWall(triangles, outer, 0, thickness, false);
      cutHoles.forEach((hole) => addWall(triangles, hole, 0, thickness, true));
      if (grooveGeometry.length) {
        const floorZ = Math.max(0, thickness - grooves[0].depth);
        addPolygonGeometryFace(triangles, grooveGeometry, floorZ, false);
        normalizePolygonGeometry(grooveGeometry).forEach((polygon) => {
          polygon.forEach((coordinates, ringIndex) => {
            const ring = coordinatesToRing(coordinates);
            if (ring.length >= 4) addWall(triangles, ring, floorZ, thickness, ringIndex === 0);
          });
        });
      }
      return triangles;
    }

    function clipGroovesToPart(partPolygon, groovePolygons) {
      if (!groovePolygons.length) return [];
      try {
        const merged = unionPolygonBatch(groovePolygons);
        if (merged.length) return polygonClipping.intersection(partPolygon, merged);
      } catch (_) {}

      // Some DXF spline offsets are locally self-touching.  Isolate them so a
      // single problematic score curve cannot abort the entire model.
      let clipped = [], skipped = 0;
      groovePolygons.forEach((polygon) => {
        try {
          const piece = polygonClipping.intersection(partPolygon, polygon);
          if (!piece.length) return;
          try { clipped = clipped.length ? polygonClipping.union(clipped, piece) : piece; }
          catch (_) { skipped++; }
        } catch (_) { skipped++; }
      });
      if (skipped) addGeometryWarning(`${skipped} self-intersecting SCORE/ENGRAVE ${countLabel(skipped, 'line')} skipped.`);
      return clipped;
    }

    function addGeometryWarning(message) {
      if (!state.warnings.includes(message)) state.warnings.push(message);
    }

    function unionPolygonBatch(polygons) {
      let merged = [];
      for (let start = 0; start < polygons.length; start += 36) {
        const batch = polygons.slice(start, start + 36);
        let batchUnion = [];
        try {
          batchUnion = polygonClipping.union(...batch);
        } catch (_) {
          batch.forEach((polygon) => {
            try { batchUnion = batchUnion.length ? polygonClipping.union(batchUnion, polygon) : [polygon]; } catch (_) {}
          });
        }
        if (!batchUnion.length) continue;
        try { merged = merged.length ? polygonClipping.union(merged, batchUnion) : batchUnion; } catch (_) {}
      }
      return merged;
    }

    function addPolygonGeometryFace(target, geometry, z, flip) {
      normalizePolygonGeometry(geometry).forEach((polygon) => {
        if (!polygon || !polygon[0]) return;
        const outer = coordinatesToRing(polygon[0]);
        const holes = polygon.slice(1).map(coordinatesToRing).filter((ring) => ring.length >= 4);
        if (outer.length >= 4 && Math.abs(polygonArea(outer)) > .0001) addTriangulatedFace(target, outer, holes, z, flip);
      });
    }

    function normalizePolygonGeometry(geometry) {
      if (!geometry || !geometry.length) return [];
      return typeof geometry[0]?.[0]?.[0] === 'number' ? [geometry] : geometry;
    }

    function ringToCoordinates(ring) {
      return closeRing(ring).map((point) => [point.x, point.y]);
    }

    function coordinatesToRing(coordinates) {
      return closeRing((coordinates || []).map((point) => ({ x: Number(point[0]), y: Number(point[1]) })));
    }

    function addTriangulatedFace(target, outerRing, holeRings, z, flip) {
      const outer = outerRing.slice(0,-1).map((p) => new THREE.Vector2(p.x,p.y));
      const holes = holeRings.map((ring) => ring.slice(0,-1).map((p) => new THREE.Vector2(p.x,p.y)));
      if (outer.length < 3) return;
      if (!THREE.ShapeUtils.isClockWise(outer)) outer.reverse();
      holes.forEach((hole) => { if (THREE.ShapeUtils.isClockWise(hole)) hole.reverse(); });
      const flat = [...outer, ...holes.flat()];
      const faces = THREE.ShapeUtils.triangulateShape(outer, holes);
      faces.forEach((face) => {
        const pts = face.map((index) => flat[index]);
        if (pts.some((p) => !p)) return;
        const tri = pts.map((p) => ({ x:p.x, y:-p.y, z }));
        target.push(flip ? [tri[0],tri[2],tri[1]] : tri);
      });
    }

    function addWall(target, ring, z0, z1, inward) {
      const points = ring.slice(0,-1);
      for (let i=0; i<points.length; i++) {
        const a=points[i], b=points[(i+1)%points.length];
        const a0={x:a.x,y:-a.y,z:z0}, b0={x:b.x,y:-b.y,z:z0}, a1={x:a.x,y:-a.y,z:z1}, b1={x:b.x,y:-b.y,z:z1};
        if (inward) { target.push([a0,b1,b0],[a0,a1,b1]); }
        else { target.push([a0,b0,b1],[a0,b1,a1]); }
      }
    }

    function strokeToPolygonGeometry(points, width, closed) {
      let pts = simplifyPolyline(points.map((p) => ({...p})), Math.max(.002, width * .03));
      if (closed && distance(pts[0], pts[pts.length-1]) < .01) pts.pop();
      if (pts.length < 2) return null;
      const half = width / 2, left = [], right = [];
      for (let i=0; i<pts.length; i++) {
        const prevIndex = i === 0 ? (closed ? pts.length-1 : 0) : i-1;
        const nextIndex = i === pts.length-1 ? (closed ? 0 : pts.length-1) : i+1;
        const d1 = normalizeVec({x:pts[i].x-pts[prevIndex].x, y:pts[i].y-pts[prevIndex].y});
        const d2 = normalizeVec({x:pts[nextIndex].x-pts[i].x, y:pts[nextIndex].y-pts[i].y});
        let normal;
        if (!closed && i===0) normal={x:-d2.y,y:d2.x};
        else if (!closed && i===pts.length-1) normal={x:-d1.y,y:d1.x};
        else {
          const n1={x:-d1.y,y:d1.x}, n2={x:-d2.y,y:d2.x};
          const m=normalizeVec({x:n1.x+n2.x,y:n1.y+n2.y});
          const denom=m.x*n2.x+m.y*n2.y;
          const miterScale=Math.abs(denom) > .2 ? clamp(1/denom,-3,3) : 1;
          normal={x:m.x*miterScale,y:m.y*miterScale};
        }
        const magnitude = Math.min(half*4, half*Math.hypot(normal.x,normal.y));
        const unit = normalizeVec(normal);
        left.push({x:pts[i].x+unit.x*magnitude,y:pts[i].y+unit.y*magnitude});
        right.push({x:pts[i].x-unit.x*magnitude,y:pts[i].y-unit.y*magnitude});
      }
      if (!closed) return [closeRing([...left, ...right.reverse()])];
      const leftRing=closeRing(left), rightRing=closeRing(right);
      const outer=Math.abs(polygonArea(leftRing)) >= Math.abs(polygonArea(rightRing)) ? leftRing : rightRing;
      const inner=outer===leftRing ? rightRing : leftRing;
      if (pointInPolygon(inner[0],outer)) return [outer,inner];
      return [closeRing([...left,...right.reverse()])];
    }

    function buildThreeModel(parts) {
      clearGroup(modelGroup);
      const palette = [0x9adfff,0x7dccf4,0xa6e6d0,0xb4c8fa,0x8dd9de,0xc4e4ff];
      parts.forEach((part) => {
        const positions = new Float32Array(part.triangles.length * 9);
        part.triangles.forEach((tri, i) => tri.forEach((p,j) => { const offset=i*9+j*3; positions[offset]=p.x; positions[offset+1]=p.y; positions[offset+2]=p.z; }));
        const geometry = new THREE.BufferGeometry(); geometry.setAttribute('position',new THREE.BufferAttribute(positions,3)); geometry.computeVertexNormals();
        const material = new THREE.MeshStandardMaterial({color:palette[part.index%palette.length],roughness:.58,metalness:.03,side:THREE.DoubleSide,polygonOffset:true,polygonOffsetFactor:1,polygonOffsetUnits:1});
        const mesh = new THREE.Mesh(geometry,material); mesh.castShadow=true; mesh.receiveShadow=true; modelGroup.add(mesh);
        const edges = new THREE.LineSegments(createFeatureEdgesGeometry(positions,28),new THREE.LineBasicMaterial({color:0x26384d,transparent:true,opacity:.42})); modelGroup.add(edges);
      });
      const box = new THREE.Box3().setFromObject(modelGroup); const center=box.getCenter(new THREE.Vector3());
      modelGroup.position.set(-center.x,-center.y,-box.min.z);
      const size=box.getSize(new THREE.Vector3()); const maxDim=Math.max(size.x,size.y,size.z,10);
      const targetZ=size.z/2;
      controls.target.set(0,0,targetZ); camera.position.set(maxDim*.85,-maxDim*1.05,maxDim*.8+targetZ); camera.near=Math.max(.01,maxDim/1000); camera.far=maxDim*50; camera.updateProjectionMatrix(); controls.update();
      grid.scale.setScalar(Math.max(1,maxDim/250));
    }

    function createFeatureEdgesGeometry(positions, thresholdDegrees) {
      const edgeMap = new Map(), cosineThreshold = Math.cos(thresholdDegrees * Math.PI / 180), precision = 1e5;
      const vertexKey = (x,y,z) => `${Math.round(x*precision)},${Math.round(y*precision)},${Math.round(z*precision)}`;
      const register = (a,b,normal) => {
        const keyA = vertexKey(a[0],a[1],a[2]), keyB = vertexKey(b[0],b[1],b[2]);
        const key = keyA < keyB ? `${keyA}|${keyB}` : `${keyB}|${keyA}`;
        const existing = edgeMap.get(key);
        if (!existing) { edgeMap.set(key,{a,b,normal,count:1,feature:false}); return; }
        existing.count++;
        const dot = Math.abs(existing.normal[0]*normal[0] + existing.normal[1]*normal[1] + existing.normal[2]*normal[2]);
        if (dot < cosineThreshold) existing.feature = true;
      };
      for (let offset=0; offset<positions.length; offset+=9) {
        const a=[positions[offset],positions[offset+1],positions[offset+2]], b=[positions[offset+3],positions[offset+4],positions[offset+5]], c=[positions[offset+6],positions[offset+7],positions[offset+8]];
        const ux=b[0]-a[0],uy=b[1]-a[1],uz=b[2]-a[2],vx=c[0]-a[0],vy=c[1]-a[1],vz=c[2]-a[2];
        let nx=uy*vz-uz*vy,ny=uz*vx-ux*vz,nz=ux*vy-uy*vx; const length=Math.hypot(nx,ny,nz)||1; nx/=length;ny/=length;nz/=length;
        const normal=[nx,ny,nz]; register(a,b,normal); register(b,c,normal); register(c,a,normal);
      }
      const linePositions=[];
      edgeMap.forEach((edge) => {
        // Earcut connects holes to the outer ring with temporary coplanar
        // bridge edges. They belong to only one horizontal face and are not
        // physical model edges. Real top/bottom boundaries are also shared by
        // a vertical wall, so they are retained as feature edges.
        const horizontal = Math.abs(edge.a[2] - edge.b[2]) < 1e-5;
        if (edge.feature || (edge.count === 1 && !horizontal)) linePositions.push(...edge.a,...edge.b);
      });
      const geometry = new THREE.BufferGeometry(); geometry.setAttribute('position',new THREE.Float32BufferAttribute(linePositions,3)); return geometry;
    }

    function initThree() {
      if (!window.THREE) { setStatus('The 3D library did not load', 'warning'); return; }
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(43,1,.1,20000);
      camera.up.set(0,0,1);
      renderer = new THREE.WebGLRenderer({canvas:els.canvas,antialias:true,alpha:true});
      renderer.setPixelRatio(Math.min(devicePixelRatio,2)); renderer.outputEncoding=THREE.sRGBEncoding; renderer.toneMapping=THREE.ACESFilmicToneMapping; renderer.toneMappingExposure=1.04;
      controls = new THREE.OrbitControls(camera,renderer.domElement); controls.enableDamping=true; controls.dampingFactor=.065; controls.screenSpacePanning=true;
      scene.add(new THREE.HemisphereLight(0xeaf7ff,0x17202e,1.35));
      const key=new THREE.DirectionalLight(0xffffff,1.35); key.position.set(160,-220,280); scene.add(key);
      const rim=new THREE.DirectionalLight(0x78d3ff,.62); rim.position.set(-220,110,170); scene.add(rim);
      modelGroup=new THREE.Group(); scene.add(modelGroup);
      grid=new THREE.GridHelper(1000,50,0x47647f,0x263448); grid.rotation.x=Math.PI/2; grid.position.z=-.08; grid.material.transparent=true; grid.material.opacity=.34; scene.add(grid);
      camera.position.set(120,-150,110); resizeThree();
      const animate=()=>{ animationFrame=requestAnimationFrame(animate); controls.update(); renderer.render(scene,camera); }; animate(); state.sceneReady=true;
    }

    function resizeThree() {
      if (!renderer) return; const rect=els.modelView.getBoundingClientRect(); const w=Math.max(1,rect.width),h=Math.max(1,rect.height);
      renderer.setSize(w,h,false); camera.aspect=w/h; camera.updateProjectionMatrix();
    }

    function switchView(view) {
      if (view === 'model' && !state.modelReady) return;
      state.activeView=view;
      els.svgView.classList.toggle('active',view==='svg'); els.modelView.classList.toggle('active',view==='model');
      els.svgMode.classList.toggle('active',view==='svg'); els.modelMode.classList.toggle('active',view==='model');
      if (view==='model') requestAnimationFrame(resizeThree);
    }

    function downloadStl() {
      if (!state.triangles.length) return;
      if (!customerLoggedIn) {
        openLoginPopup();
        return;
      }
      setLoading(true,'Writing the binary STL…');
      setTimeout(() => {
        try {
          const buffer = trianglesToBinaryStl(state.triangles);
          const blob = new Blob([buffer],{type:'model/stl'}); const url=URL.createObjectURL(blob); const a=document.createElement('a');
          a.href=url; a.download=(state.file ? state.file.name.replace(/\.(svg|dxf)$/i,'') : 'laser-cut-model')+'.stl'; document.body.appendChild(a); a.click(); a.remove();
          setTimeout(()=>URL.revokeObjectURL(url),1500); toast('Your STL file is ready to download.');
        } catch(error) { console.error(error); toast('Could not write the STL file.','error'); }
        finally { setLoading(false); }
      },40);
    }

    function trianglesToBinaryStl(triangles) {
      const buffer=new ArrayBuffer(84+triangles.length*50); const view=new DataView(buffer); const header='Vector Painter · Laser Cut SVG/DXF to STL Converter';
      for(let i=0;i<header.length&&i<80;i++) view.setUint8(i,header.charCodeAt(i)); view.setUint32(80,triangles.length,true);
      let offset=84;
      triangles.forEach((tri)=>{
        const n=triangleNormal(tri); [n,...tri].forEach((p)=>{view.setFloat32(offset,p.x,true);view.setFloat32(offset+4,p.y,true);view.setFloat32(offset+8,p.z,true);offset+=12;});
        view.setUint16(offset,0,true); offset+=2;
      }); return buffer;
    }

    function triangleNormal([a,b,c]) {
      const ux=b.x-a.x,uy=b.y-a.y,uz=b.z-a.z,vx=c.x-a.x,vy=c.y-a.y,vz=c.z-a.z;
      const x=uy*vz-uz*vy,y=uz*vx-ux*vz,z=ux*vy-uy*vx,l=Math.hypot(x,y,z)||1; return{x:x/l,y:y/l,z:z/l};
    }

    function triangleBounds(triangles) {
      let minX=Infinity,minY=Infinity,minZ=Infinity,maxX=-Infinity,maxY=-Infinity,maxZ=-Infinity;
      triangles.flat().forEach((p)=>{minX=Math.min(minX,p.x);minY=Math.min(minY,p.y);minZ=Math.min(minZ,p.z);maxX=Math.max(maxX,p.x);maxY=Math.max(maxY,p.y);maxZ=Math.max(maxZ,p.z);});
      return{width:maxX-minX,height:maxY-minY,depth:maxZ-minZ};
    }

    function centerTrianglesOnBuildPlate(triangles) {
      const vertices = new Set();
      triangles.forEach((triangle) => triangle.forEach((point) => vertices.add(point)));
      let minX=Infinity,minY=Infinity,minZ=Infinity,maxX=-Infinity,maxY=-Infinity;
      vertices.forEach((point) => {
        minX=Math.min(minX,point.x); minY=Math.min(minY,point.y); minZ=Math.min(minZ,point.z);
        maxX=Math.max(maxX,point.x); maxY=Math.max(maxY,point.y);
      });
      const offsetX=-(minX+maxX)/2, offsetY=-(minY+maxY)/2, offsetZ=-minZ;
      vertices.forEach((point) => { point.x+=offsetX; point.y+=offsetY; point.z+=offsetZ; });
    }

    function cleanRing(points) { return closeRing(simplifyPolyline(points.map((p)=>({...p})),.006)); }
    function closeRing(points) { const out=points.slice(); if (out.length&&distance(out[0],out[out.length-1])>.0001) out.push({...out[0]}); return out; }
    function orientRing(ring, clockwise) { const isClockwise=polygonArea(ring)>0; return isClockwise===clockwise?ring:ring.slice().reverse(); }
    function polygonArea(points) { let area=0; for(let i=0;i<points.length-1;i++) area+=points[i].x*points[i+1].y-points[i+1].x*points[i].y; return area/2; }
    function pointInPolygon(point, ring) { let inside=false; for(let i=0,j=ring.length-1;i<ring.length;j=i++){const a=ring[i],b=ring[j];if(((a.y>point.y)!==(b.y>point.y))&&(point.x<(b.x-a.x)*(point.y-a.y)/((b.y-a.y)||1e-12)+a.x))inside=!inside;} return inside; }
    function simplifyPolyline(points,tolerance) { if(points.length<3)return points; const out=[points[0]]; for(let i=1;i<points.length-1;i++)if(distance(points[i],out[out.length-1])>=tolerance)out.push(points[i]); out.push(points[points.length-1]); return out; }
    function ringBounds(ring){let minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;ring.forEach(p=>{minX=Math.min(minX,p.x);minY=Math.min(minY,p.y);maxX=Math.max(maxX,p.x);maxY=Math.max(maxY,p.y);});return{minX,minY,maxX,maxY};}
    function bboxOverlap(a,b){return a.minX<=b.maxX&&a.maxX>=b.minX&&a.minY<=b.maxY&&a.maxY>=b.minY;}
    function segmentsIntersect(a,b,c,d){const cross=(p,q,r)=>(q.x-p.x)*(r.y-p.y)-(q.y-p.y)*(r.x-p.x);const x1=cross(a,b,c),x2=cross(a,b,d),x3=cross(c,d,a),x4=cross(c,d,b);return((x1>0&&x2<0)||(x1<0&&x2>0))&&((x3>0&&x4<0)||(x3<0&&x4>0));}
    function distance(a,b){return Math.hypot(a.x-b.x,a.y-b.y);}
    function normalizeVec(v){const l=Math.hypot(v.x,v.y)||1;return{x:v.x/l,y:v.y/l};}
    function parseCssPx(value){const n=parseFloat(value);return Number.isFinite(n)?n:0;}
    function hexRgb(hex){return[parseInt(hex.slice(1,3),16),parseInt(hex.slice(3,5),16),parseInt(hex.slice(5,7),16)];}
    function clamp(value,min,max){return Math.min(max,Math.max(min,value));}
    function formatNumber(value,decimals=2){return Number(value.toFixed(decimals)).toString();}
    function formatBytes(bytes){if(bytes<1024)return`${bytes} B`;if(bytes<1048576)return`${formatNumber(bytes/1024,1)} KB`;return`${formatNumber(bytes/1048576,1)} MB`;}
    function countLabel(n,singular){
      if(Math.abs(n)===1)return singular;
      if(/[^aeiou]y$/i.test(singular))return`${singular.slice(0,-1)}ies`;
      if(/(?:s|x|z|ch|sh)$/i.test(singular))return`${singular}es`;
      return`${singular}s`;
    }
    function nextFrame(){return new Promise((resolve)=>requestAnimationFrame(()=>resolve()));}
    function yieldToBrowser(){return new Promise((resolve)=>setTimeout(resolve,0));}
    function clearGroup(group){while(group.children.length){const child=group.children.pop();child.geometry?.dispose();if(Array.isArray(child.material))child.material.forEach(m=>m.dispose());else child.material?.dispose();}}
    function setLoading(visible,text){if(text)els.loadingText.textContent=text;els.loading.classList.toggle('visible',visible);}
    function setStatus(text,type=''){els.statusText.textContent=text;els.statusbar.className='statusbar'+(type?` ${type}`:'');}
    function toast(message,type='success',duration=3800){const item=document.createElement('div');item.className=`toast ${type}`;item.textContent=message;els.toastStack.appendChild(item);setTimeout(()=>{item.style.opacity='0';item.style.transform='translateY(-5px)';item.style.transition='.18s ease';setTimeout(()=>item.remove(),220);},duration);}
  })();